import React from 'react'
import { Provider } from 'react-redux'
import App from './App'
import { store } from './store/store'
import { MsalProvider } from '@azure/msal-react'
import { Configuration, PublicClientApplication } from '@azure/msal-browser'

const configuration: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
  },
}

const pca = new PublicClientApplication(configuration)

function AppWrapper() {
  return (
    <MsalProvider instance={pca}>
      <Provider store={store}>
        <App />
      </Provider>
    </MsalProvider>
  )
}

export default AppWrapper
